import s from './NextPayout.module.scss';
import cx from 'classnames';
import CircleProgressBar from "@/shared/ui/CircleProgressBar";

type NextPayoutProps = {
  progress: number;
  payoutTitle: string;
  payoutValue: string;
  className?: string;
}

const NextPayout = (props: NextPayoutProps) => {
  const {
    progress,
    payoutTitle,
    payoutValue,
    className = '',
  } = props;

  return (
    <div className={cx(s.root, className)}>
      <CircleProgressBar progress={progress} />
      <div className={s.content}>
        <div className={s.title}>
          {payoutTitle}
        </div>
        <div className={s.value}>
          {payoutValue}
        </div>
      </div>
    </div>
  );
}

export default NextPayout;
